import { Pipe, PipeTransform } from '@angular/core';
import { ClientNameService } from '../services/client-name.service';

@Pipe({
  name: 'clientName',
  pure: true
})
export class ClientNamePipe implements PipeTransform {
  constructor(private clientNameService: ClientNameService) {}

  transform(client: { firstName?: string; lastName?: string }, settings: any[]): string {
    if (!client || !settings) {
      return '';
    }

    return this.clientNameService.formatClientName(client, settings);
  }
}

